/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedRelatedPages_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SharedRespLinksBlock_viewer" | "SharedMobileLinksBlock_viewer" | "SharedAmpLinksBlock_viewer">;
    readonly " $refType": "SharedRelatedPages_viewer";
};
export type SharedRelatedPages_viewer$data = SharedRelatedPages_viewer;
export type SharedRelatedPages_viewer$key = {
    readonly " $data"?: SharedRelatedPages_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedRelatedPages_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedRelatedPages_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedMobileLinksBlock_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedAmpLinksBlock_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '5cb216868c9137c6343c2ce342293415';
export default node;
